import { PublicClientApplication, EventType, AccountInfo } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
  const isLogin = event.eventType === EventType.LOGIN_SUCCESS;
  const isToken = event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS;

  if ((isLogin || isToken) && event.payload) {
    const maybeAccount = (event.payload as any).account as AccountInfo | undefined;
    if (maybeAccount) {
      msalInstance.setActiveAccount(maybeAccount);
    }
  }
});
